if (!customElements.get('cookie-banner')) {
  customElements.define(
    'cookie-banner',
    class CookieBanner extends ModalElement {
      constructor() {
        super();
    
        if (!theme.config.isTouch || Shopify.designMode) {
          this.init();
        }
        else {
          new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
        }
      }
    
      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }
    
      get delay() {
        return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 5;
      }
    
      get acceptButton() {
        return this.querySelector('button[name="accept"]');
      }
    
      get declineButton() {
        return this.querySelector('button[name="decline"]');
      }
    
      init() {
        if (this.initialized) return;
        this.initialized = true;
    
        if (this.testMode) {
          this.load(this.delay);
          return;
        }
    
        window.Shopify.loadFeatures([{
          name: 'consent-tracking-api',
          version: '0.1',
          onLoad: this.onConsentLibraryLoaded.bind(this)
        }]);
      }
    
      load(delay) {
        if (Shopify.designMode) return;
    
        setTimeout(() => this.show(), delay * 1000);
    
        if (this.acceptButton) this.acceptButton.addEventListener('click', this.acceptPolicy.bind(this));
        if (this.declineButton) this.declineButton.addEventListener('click', this.declinePolicy.bind(this));
      }
    
      acceptPolicy() {
        this.hide();
        window.Shopify.customerPrivacy?.setTrackingConsent({
          analytics: true,
          marketing: true,
          preferences: true,
          sale_of_data: true
        }, this.noop);

        document.addEventListener('trackingConsentAccepted', () => {
          console.log('trackingConsentAccepted event fired');
        });
      }
    
      declinePolicy() {
        this.hide();
        window.Shopify.customerPrivacy?.setTrackingConsent({
          analytics: false,
          marketing: false,
          preferences: false,
          sale_of_data: false
        }, this.noop);
      }
    
      onConsentLibraryLoaded() {
        const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
        const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();
    
        if(!userCanBeTracked && userTrackingConsent === 'no_interaction') {
          this.load(this.delay);
        }
      }
    
      noop() {
      }
    
      afterHide() {
        super.afterHide();
        document.body.classList.remove('has-cookie-banner');
      }

      afterShow() {
        super.afterShow();
        document.body.classList.add('has-cookie-banner');
      }
    }
  );
}

// Tercihleri Yönet Modali
(function() {
  const modal = document.getElementById('CookiePreferencesModal');
  const manageBtn = document.getElementById('CookieManageBtn');
  const closeBtn = document.getElementById('CookieModalClose');
  const acceptAllBtn = document.getElementById('CookieAcceptAll');
  const declineAllBtn = document.getElementById('CookieDeclineAll');
  const saveBtn = document.getElementById('CookieSavePrefs');

  function openModal() {
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }

  function saveAndClose(analytics, marketing, preferences) {
    window.Shopify?.customerPrivacy?.setTrackingConsent({
      analytics: analytics,
      marketing: marketing,
      preferences: preferences,
      sale_of_data: marketing
    }, function(){});
    closeModal();
    document.getElementById('CookieBanner')?.hide?.();
  }

  if (manageBtn) manageBtn.addEventListener('click', openModal);
  if (closeBtn) closeBtn.addEventListener('click', closeModal);

  if (acceptAllBtn) acceptAllBtn.addEventListener('click', function() {
    document.getElementById('cookie_preferences').checked = true;
    document.getElementById('cookie_marketing').checked = true;
    document.getElementById('cookie_analytics').checked = true;
    saveAndClose(true, true, true);
  });

  if (declineAllBtn) declineAllBtn.addEventListener('click', function() {
    document.getElementById('cookie_preferences').checked = false;
    document.getElementById('cookie_marketing').checked = false;
    document.getElementById('cookie_analytics').checked = false;
    saveAndClose(false, false, false);
  });

  if (saveBtn) saveBtn.addEventListener('click', function() {
    const analytics = document.getElementById('cookie_analytics').checked;
    const marketing = document.getElementById('cookie_marketing').checked;
    const preferences = document.getElementById('cookie_preferences').checked;
    saveAndClose(analytics, marketing, preferences);
  });

  // Çerezleri Reddet linki, default olarak kabul ediyor..
  document.addEventListener('click', function(e) {
    const declineLink = e.target.closest('a[href="#cookie-decline"]');
    if (declineLink) {
      e.preventDefault();
      window.Shopify?.customerPrivacy?.setTrackingConsent({
        analytics: true,
        marketing: true,
        preferences: true,
        sale_of_data: true
      }, function(){});
      document.getElementById('CookieBanner')?.hide?.();
    }
  });

  if (modal) modal.addEventListener('click', function(e) {
    if (e.target === modal) closeModal();
  });

  // Buton margin mobil/web ayarı
function fixCookieButtonsMobile() {
  const btnWrapper = document.querySelector('.cookie__buttons > div');
  const content = document.querySelector('.cookie-modal .drawer__content');
  const acceptBtn = document.querySelector('.cookie__buttons button[name="accept"]');
  if (!btnWrapper) return;
  if (window.innerWidth < 640) {
    btnWrapper.style.marginTop = '8px';
    if (content) content.style.paddingTop = '20px';
    if (acceptBtn) acceptBtn.style.marginTop = '14px';
  } else {
    btnWrapper.style.marginTop = '-8px';
    if (content) content.style.paddingTop = '4px';
    if (acceptBtn) acceptBtn.style.marginTop = '0px';
  }
}

  fixCookieButtonsMobile();
  window.addEventListener('resize', fixCookieButtonsMobile);
})();